/* Viroxa Blush 2.0 */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* Reveal on scroll */
  var rv = $$('.rv');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rv.forEach(function (el) { io.observe(el); });
  } else { rv.forEach(function (el) { el.classList.add('in'); }); }

  /* Header shadow on scroll */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* Drawer */
  var drawer = $('[data-menu-drawer]'), openBtn = $('[data-menu-open]');
  if (drawer && openBtn) {
    var close = function () { drawer.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; openBtn.focus(); };
    openBtn.addEventListener('click', function () { drawer.hidden = false; openBtn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; var c = $('[data-menu-close]', drawer); if (c) c.focus(); });
    $('[data-menu-close]', drawer).addEventListener('click', close);
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* Hero word rotator */
  $$('[data-rotator]').forEach(function (r) {
    var words = $$('span', r); if (words.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      var cur = words[i]; cur.classList.remove('is-on'); cur.classList.add('is-out');
      setTimeout(function () { cur.classList.remove('is-out'); }, 500);
      i = (i + 1) % words.length; words[i].classList.add('is-on');
    }, 2600);
  });

  /* Engraving helpers */
  function setFont(els, idx) {
    els.forEach(function (el) {
      el.setAttribute('class', (el.getAttribute('class') || '').replace(/\beng-f\d\b/g, '').trim() + ' eng-f' + idx);
    });
  }
  function fitText(el, base) {
    if (!el || !el.getComputedTextLength) return;
    el.style.fontSize = base + 'px';
    try {
      var len = el.getComputedTextLength(), max = parseFloat(el.getAttribute('data-max')) || 200;
      if (len > max) el.style.fontSize = Math.max(12, Math.floor(base * max / len)) + 'px';
    } catch (e) {}
  }

  /* Fit engraved text inside every illustration */
  function fitAll() {
    $$('[data-eng-l1], [data-eng-l2]').forEach(function (t) {
      if (!t.hasAttribute('data-base')) t.setAttribute('data-base', parseFloat(t.style.fontSize) || 30);
      fitText(t, parseFloat(t.getAttribute('data-base')));
    });
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll); else fitAll();
  window.addEventListener('load', fitAll);

  /* Hero studio */
  $$('[data-studio]').forEach(function (studio) {
    var tabs = $$('[data-studio-tab]', studio), arts = $$('[data-studio-art]', studio);
    var stage = $('[data-studio-stage]', studio), price = $('[data-studio-price]', studio), cta = $('[data-studio-cta]', studio);
    var l1 = $('[data-studio-l1]', studio), l2 = $('[data-studio-l2]', studio);
    var fontIdx = ($('[data-studio-font]:checked', studio) || { value: 1 }).value;
    function texts(sel) { return $$(sel, studio); }
    function render() {
      setFont(texts('[data-eng-l1]'), fontIdx);
      texts('[data-studio-ov1]').forEach(function (t) { t.textContent = l1.value || 'Your Name'; t.className = 'eng-f' + fontIdx; });
      texts('[data-studio-ov2]').forEach(function (t) { t.textContent = l2.value; });
      texts('[data-eng-l1]').forEach(function (t) { t.textContent = l1.value || 'Your Name'; });
      texts('[data-eng-l2]').forEach(function (t) { t.textContent = l2.value; });
      fitAll();
      updateLink();
    }
    function activeTab() { return tabs.filter(function (t) { return t.classList.contains('is-active'); })[0] || tabs[0]; }
    function updateLink() {
      if (!cta) return;
      var base = activeTab().getAttribute('data-link') || '/collections/all';
      var q = 'engrave=' + encodeURIComponent(l1.value) + '&engrave2=' + encodeURIComponent(l2.value) + '&font=' + fontIdx;
      cta.href = base + (base.indexOf('?') > -1 ? '&' : '?') + q;
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('is-active')) return;
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab); });
        stage.classList.add('is-swapping');
        setTimeout(function () {
          arts.forEach(function (a, j) { a.hidden = j !== i; });
          if (price) { var p = tab.getAttribute('data-price'); price.textContent = p; price.hidden = !p; }
          render();
          stage.classList.remove('is-swapping');
        }, reduce ? 0 : 220);
      });
    });
    [l1, l2].forEach(function (inp) { if (inp) inp.addEventListener('input', render); });
    $$('[data-studio-font]', studio).forEach(function (r) { r.addEventListener('change', function () { fontIdx = r.value; render(); }); });
    if (price) { var p0 = activeTab().getAttribute('data-price'); price.textContent = p0; price.hidden = !p0; }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render); else render();
  });

  /* Sliders */
  $$('[data-slider-section]').forEach(function (sec) {
    var track = $('[data-slider-track]', sec), prev = $('[data-slider-prev]', sec), next = $('[data-slider-next]', sec), bar = $('[data-slider-bar]', sec);
    if (!track || !next) return;
    function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + 16 : 300; }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft > max - 4;
      if (bar) { var ratio = track.clientWidth / track.scrollWidth; bar.style.width = (ratio * 100) + '%'; bar.style.transform = 'translateX(' + (max ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0) + '%)'; }
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
  });

  /* Gift finder */
  $$('[data-finder]').forEach(function (f) {
    var go = $('[data-finder-go]', f);
    function upd() {
      var occ = ($('input[name="finder-occ"]:checked', f) || {}).value;
      var who = ($('input[name="finder-who"]:checked', f) || {}).value;
      go.href = occ || who || '/collections/all';
    }
    $$('input', f).forEach(function (i) { i.addEventListener('change', upd); }); upd();
  });

  /* Auto-submit, confirm, recover */
  $$('[data-auto-submit]').forEach(function (el) { el.addEventListener('change', function () { el.form.submit(); }); });
  $$('[data-confirm]').forEach(function (b) { b.addEventListener('click', function (e) { if (!window.confirm(b.dataset.confirm)) e.preventDefault(); }); });
  var rec = $('[data-toggle-recover]');
  if (rec) {
    rec.addEventListener('click', function (e) { e.preventDefault(); var r = $('#recover'); r.hidden = !r.hidden; });
    if (location.hash === '#recover') $('#recover').hidden = false;
  }

  /* ---------- Product page ---------- */
  var pEl = $('[data-product]');
  if (!pEl) return;
  var pj = JSON.parse($('[data-product-json]', pEl).textContent);
  var form = $('#ProductForm', pEl), idInput = $('[data-variant-id]', form), addBtn = $('[data-add-btn]', form);
  var priceEl = $('[data-price-current]', pEl), cmpEl = $('[data-price-compare]', pEl), saveEl = $('[data-price-save]', pEl), stickyPrice = $('[data-sticky-price]', pEl);
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
  function money(c) { try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: cur, minimumFractionDigits: c % 100 === 0 ? 0 : 2 }).format(c / 100); } catch (e) { return '₹' + (c / 100).toFixed(2); } }

  var slides = $$('.product__slide', pEl), thumbs = $$('[data-thumb]', pEl);
  function showMedia(id) {
    if (!id) return;
    slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === String(id)); });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === String(id)); });
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });
  var act = $('.product__slide.is-active', pEl); if (act) showMedia(act.dataset.mediaId);

  var opts = $$('[data-option-index]', form);
  function updateVariant() {
    var sel = [];
    opts.forEach(function (i) { if (i.checked) sel[+i.dataset.optionIndex] = i.value; });
    sel.forEach(function (v, i) { var l = $('[data-option-label="' + i + '"]', form); if (l) l.textContent = v; });
    var v = pj.variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
    if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
    idInput.value = v.id; priceEl.textContent = money(v.price); if (stickyPrice) stickyPrice.textContent = money(v.price);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    cmpEl.hidden = !onSale; if (saveEl) saveEl.hidden = !onSale;
    if (onSale) { cmpEl.textContent = money(v.compare_at_price); if (saveEl) saveEl.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
    addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    if (v.featured_media) showMedia(v.featured_media.id);
    var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
  }
  opts.forEach(function (i) { i.addEventListener('change', updateVariant); });

  $$('[data-qty]', form).forEach(function (b) {
    b.addEventListener('click', function () { var q = $('.qty__input', form); q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.qty, 10)); });
  });

  /* Live engraving: on illustration (no photos) or overlay (photos) */
  var in1 = $('[data-engrave-input="1"]', form), in2 = $('[data-engrave-input="2"]', form);
  var overlay = $('[data-preview]', pEl), ov1 = overlay && $('[data-preview-line1]', overlay), ov2 = overlay && $('[data-preview-line2]', overlay);
  var svg1 = $$('[data-eng-l1]', pEl), svg2 = $$('[data-eng-l2]', pEl);
  var fontIdx = 0;
  function renderEngrave() {
    if (!in1) return;
    var a = in1.value, b = in2 ? in2.value : '';
    setFont(svg1, fontIdx);
    svg1.forEach(function (t) { t.textContent = a || 'Your Name'; });
    svg2.forEach(function (t) { t.textContent = b; });
    fitAll();
    if (overlay) {
      overlay.hidden = !(a || b);
      ov1.textContent = a; ov2.textContent = b;
      ov1.className = 'font-' + fontIdx;
    }
    $$('[data-engrave-input]', form).forEach(function (inp) { var c = $('[data-counter="' + inp.id + '"]', form); if (c) c.textContent = inp.value.length + '/' + inp.maxLength; });
  }
  if (in1) {
    var params = new URLSearchParams(location.search);
    if (params.get('engrave')) in1.value = params.get('engrave').slice(0, in1.maxLength);
    if (in2 && params.get('engrave2')) in2.value = params.get('engrave2').slice(0, in2.maxLength);
    var pf = params.get('font');
    var fontRadios = $$('[data-font-index]', form);
    if (pf && fontRadios[+pf]) { fontRadios[+pf].checked = true; fontIdx = +pf; }
    [in1, in2].forEach(function (i) { if (i) i.addEventListener('input', renderEngrave); });
    fontRadios.forEach(function (r) { r.addEventListener('change', function () { fontIdx = +r.dataset.fontIndex; renderEngrave(); }); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(renderEngrave); else renderEngrave();
    if (params.get('engrave')) toast('Your engraving is ready to review ✦');
  }

  /* Sticky buy bar */
  var sticky = $('[data-sticky-buy]', pEl), go = $('[data-sticky-go]', pEl);
  if (sticky && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (es) {
      var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', !show);
      go.tabIndex = show ? 0 : -1; document.body.classList.toggle('has-sticky-buy', show);
    });
    sio.observe(addBtn);
    go.addEventListener('click', function () {
      var target = in1 || addBtn; target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { target.focus({ preventScroll: true }); }, 400);
    });
  }

  form.addEventListener('submit', function () { setTimeout(function () { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }, 0); });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (opts.length) updateVariant(); else { var v = pj.variants[0]; addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
  });
})();

/* Photo engraving upload preview */
(function () {
  var box = document.querySelector('[data-photo]');
  if (!box) return;
  var input = box.querySelector('[data-photo-input]'), img = box.querySelector('[data-photo-preview]'),
      empty = box.querySelector('[data-photo-empty]'), change = box.querySelector('[data-photo-change]');
  input.addEventListener('change', function () {
    var f = input.files && input.files[0];
    box.classList.remove('is-error');
    if (!f) { img.hidden = true; empty.hidden = false; change.hidden = true; return; }
    if (f.size > 20 * 1024 * 1024) { alertBox('That photo is over 20 MB. Please choose a smaller one.'); input.value = ''; return; }
    if (/^image\/(png|jpe?g|webp|gif)$/.test(f.type)) { img.src = URL.createObjectURL(f); img.hidden = false; empty.hidden = true; }
    else { empty.querySelector('b').textContent = f.name; }
    change.hidden = false;
  });
  function alertBox(msg) { box.classList.add('is-error'); empty.querySelector('small').textContent = msg; }
  var form = input.form;
  if (form) form.addEventListener('submit', function (e) {
    if (!input.files || !input.files.length) { e.preventDefault(); e.stopImmediatePropagation(); alertBox('Please upload the photo you want engraved.'); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }, true);
})();
